import {
  withTranslation,
} from 'react-i18next';

import ChampionshipDescriptionSectionView from './ChampionshipDescriptionSectionView';

const TranslatedComponent = withTranslation()(ChampionshipDescriptionSectionView);

const Component = TranslatedComponent;

export default Component;
